import React, { useState, useEffect } from 'react'
import { Box, Flex, Button, Select, Textarea } from '@mantine/core'
import { getTemplateBroadcastPackageShipment } from '../../../../../services/package'
import { sendBroadcastMessageOrder } from '../../../../../services/orders'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { validation } from '../../../../../plugins/validation'
import LoadingData from '../../../../ui/LoadingData' 

const defaultVal = {
  phone: null,
  content: ''
}

const formValidation = {
  phone: {
    isError: false,
    message: ''
  },
  content: {
    isError: false,
    message: ''
  }
}

const FormBroadcastPackageShipment = ({ dataPackage, onCloseForm }) => {
  const [loading, setLoading] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [contactList, setContactList] = useState([])

  const handleSendMessage = async (form) => {
    setLoadingForm(true)
    const validateForm = {
      phone: form.phone,
      content: form.content
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const isGroupContact = contactList.find((val) => val.value === form.phone).is_group || false
    const payload = {
      phone: form.phone,
      is_group: isGroupContact,
      content: form.content
    }
    try {
      const response = await sendBroadcastMessageOrder(payload)
      if (response.success) {
        notificationSuccess('Send Broadcast Message Successfully', 'You have successfully sent a broadcast message')
        onCloseForm()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Send Broadcast Message Failed', `${errorMessage ? errorMessage : 'Please contact administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetTemplateBroadcastMsg = async (dataPackage) => {
    setLoading(true)
    const params = {
      order_id: dataPackage.order_id
    }
    try {
      const response = await getTemplateBroadcastPackageShipment(dataPackage.id, params)
      if (response.success) {
        const { contact, content } = response

        const remapData = contact.map((val) => {
          return {
            value: val.phone,
            label: `${val.name} - ${val.phone}`,
            is_group: val.is_group
          }
        })
        setContactList(remapData)
        handleChangeForm('content', content)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (dataPackage !== null) {
      handleGetTemplateBroadcastMsg(dataPackage)
    }
    // eslint-disable-next-line
  }, [dataPackage])

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const loadForm = () => {
    return (
      <Box>
        <Box mb='sm'>
          <Select
            name='phone'
            value={formData.phone}
            label='Select Recipient'
            data={contactList}
            onChange={(val) => handleChangeForm('phone', val)}
            error={validationForm.phone.isError ? `${validationForm.phone.message}` : ''}
            withAsterisk
            size='xs'
            allowDeselect={false}
          />
        </Box>
        <Box mb='sm'>
          <Textarea
            name='content'
            label="Message"
            description='Please edit this message as needed. Message are editable.'
            value={formData.content}
            onChange={(val) => handleChangeForm('content', val.target.value)}
            error={validationForm.content.isError ? `${validationForm.content.message}` : ''}
            withAsterisk
            size='xs'
            autosize
            minRows={14}
            maxRows={14}
          />
        </Box>
        <Box mb='xl'>
          <Button size='xs' loading={loadingForm} variant="filled" disabled={formData.phone === null} onClick={() => handleSendMessage(formData)}>Send Message</Button>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loading ? <LoadingData /> : loadForm()}
    </Box>
  )
}

export default FormBroadcastPackageShipment